import React, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, TextField, InputAdornment } from '@mui/material';
import EnvList from './EnvList';
import TenantList from './TenantList';
import InstanceList from './InstanceList';
import { useSearch } from '../Keyvault/SearchContext';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';


const Tenants: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { searchText, setSearchText } = useSearch();
  const location = useLocation();

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  //this useffect is used so that when we navigate we can get back to the active tab not the tab index 0
  useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setTabIndex(location.state.activeTab);
    }
  }, [location.state]);







  return (
    <Box
      sx={{
        bgcolor: '#f5f5f5',
        height: '100%',
        minHeight: '100vh',
        overflowY: 'auto',
        p: 4,
      }}
    >
      {/* Search Bar*/}
      <Box display="flex" justifyContent="center" mb={4}>
        <TextField
          variant="outlined"
          placeholder="Search.."
          size="small"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            style: {
              background: 'white',
              borderRadius: 8,
              minWidth: 300,
              width: '100%',
              maxWidth: 500,

            },
          }}
        />
      </Box>

      {/* Tab Header */}
      <Box
        sx={{
          mb: 6,
          pb: 1,
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: 'start',
        }}
      >

        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: '#734bd1' } }}
          aria-label="Tenant Tabs"
          sx={{
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              mx: 3,
              color: '#555',
            },
            '& .Mui-selected': {
              color: '#734bd1',
            },
          }}
        >
          <Tab label="ENVIRONMENTS" />
          <Tab label="TENANTS" />
          <Tab label="INSTANCES" />
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box className="mt-4 px-8">
        {tabIndex === 0 && <EnvList />}
        {tabIndex === 1 && <TenantList />}
        {tabIndex === 2 && <InstanceList />}
      </Box>
    </Box>
  );
};

export default Tenants;
